import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React from 'react';

import { ShareLinks } from '$partials/editorials/index.js';
import { ModuleDispatcher } from '$partials/modules/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * NewsPage Modal
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const NewsPage = ({
    canonicalUrl,
    page
}) => {
    return (
        <div className='overflow-hidden rounded-md'>
            <main
                className='bg-white min-h-screen relative'
                id='main-content'>
                <div className='max-w-container bg-white mb-20 sm:pb-40 md:pb-60'>
                    <div className='modal-container-padding-right flex flex-wrap max-w-container'>
                        {/* Left Sidebar */}
                        <div className='w-sidebar'>
                        </div>

                        {/* Main content */}
                        <div className='flex-1 flex flex-wrap self-start layout-negative-margin'>
                            <section className='w-full'>
                                <div className='layout-item-padding'>
                                    <h1 className='type-style-3 mb-15'>
                                        {page?.title}
                                    </h1>
                                    {page?.subtitle &&
                                        <h2
                                            className='type-style-4 font-normal py-15'
                                            style={{ lineHeight: '140%'}}>
                                            {page?.subtitle}
                                        </h2>
                                    }
                                </div>
                            </section>
                        </div>

                        <div className='layout-container-padding-right flex max-w-container bg-white pt-25 sm:pt-35 md:pt-45 pb-40 md:pb-50'>
                            {/* Left Sidebar */}
                            <div className='w-sidebar'>
                                <div className='flex flex-col items-center'>
                                </div>
                            </div>

                            {/* Main content */}
                            <div className='relative flex-1 flex flex-wrap self-start layout-negative-margin'>
                                {/* Details */}
                                <div className='z-20 right-0 layout-item-padding'>
                                    {(page?.author?.title || page?.customAuthorLabel) &&
                                        <a href={page?.author?.url}>
                                            <span className='type-style-5'>
                                                By {page?.customAuthorLabel || page.author?.title}
                                            </span>
                                        </a>
                                    }
                                    {page?.publicationDate &&
                                        <p className='type-style-7 pt-5'>
                                            {dayjs(page.publicationDate).format('DD MMM YYYY')}
                                        </p>
                                    }
                                    <div className='flex flex-wrap sm:flex-nowrap gap-x-50 sm:gap-x-40'>
                                        {page?.funds?.edges.length > 0 && page?.funds?.edges.map(({node: fund}, i) => {
                                            return (
                                                <div
                                                    className={'block md:inline-block md:w-6/12 mt-25 md:mt-30'}
                                                    key={i}>
                                                    <a
                                                        className={`type-style-8 ${fund?.branding?.toLowerCase()}-border background-6px pl-20`}
                                                        href={fund.url}
                                                        target='_self'>
                                                        {fund?.title}
                                                    </a>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <ShareLinks url={canonicalUrl}/>
                                </div>
                            </div>
                        </div>

                        {/* Module dispatcher */}
                        {page.modules?.length > 0 && (
                            <section className='news-modules'>
                                {page.modules.map((module, i, { length, ...modules }) => {
                                    const isLast = length - 1 === i;
                                    const nextModuleType = modules[i + 1]?.__typename;
                                    const previousModuleType = modules[i - 1]?.__typename;
                                    return (
                                        <ModuleDispatcher
                                            {...module}
                                            isInModal={true}
                                            isLast={isLast}
                                            key={i + module?.id}
                                            nextModuleType={nextModuleType}
                                            pageTypename={page.__typename}
                                            previousModuleType={previousModuleType}/>
                                    );
                                })}
                            </section>
                        )}

                    </div>
                </div>
            </main>

        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */


const propTypes = {
    canonicalUrl: PropTypes.string.isRequired,
    page: PropTypes.shape({
        __typename: PropTypes.string,
        author: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string
        }),
        customAuthorLabel: PropTypes.string,
        funds: PropTypes.object,
        modules: PropTypes.array,
        listingText: PropTypes.string,
        publicationDate: PropTypes.string,
        searchDescription: PropTypes.string,
        subtitle: PropTypes.string,
        title: PropTypes.string,
    })
};

NewsPage.propTypes = propTypes;

export default NewsPage;
